/* src/app/error/error.component.css */
.template {
  margin-left: auto;
  text-align: center;
  font-size: xx-large;
}
/*# sourceMappingURL=error.component.css.map */
